import { SvgIconProps } from './icon-props';

export default function ChatDefaultCircle({ height = 32, width = 32 }: SvgIconProps) {
	return (
		<svg
			version="1.2"
			baseProfile="tiny-ps"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 30 31"
			width={width}
			height={height}
		>
			<path
				fillRule="evenodd"
				d="M0 15.18c-.01-1.98.37-3.95 1.12-5.78A15.106 15.106 0 0 1 15 0c.99 0 1.97.1 2.93.3.97.19 1.91.48 2.82.86.91.38 1.78.85 2.59 1.4.82.56 1.58 1.19 2.27 1.89a15.232 15.232 0 0 1 4.1 7.78c.2.97.29 1.96.29 2.95.01 1.98-.37 3.95-1.11 5.78-.75 1.84-1.85 3.51-3.25 4.92A15.106 15.106 0 0 1 15 30.37a15.106 15.106 0 0 1-10.64-4.49c-1.4-1.41-2.5-3.08-3.25-4.92A15.24 15.24 0 0 1 0 15.18zm15.27-8.12c-4.82 0-8.72 3.3-8.72 7.38.02.57.1 1.14.26 1.69.16.54.39 1.07.68 1.56.29.49.65.94 1.05 1.35.41.4.87.74 1.36 1.03l-1.68 4.22 5-2.81.49.12c.17.04.34.07.5.1a8.797 8.797 0 0 0 1.01.13c4.82 0 8.73-3.31 8.73-7.39s-3.91-7.39-8.73-7.39l.05.01z"
			/>
		</svg>
	);
}
